<sb-card *ngIf="!integratedChart" [loading]="!airTimeData.loadingDone" [loadingDelay]="1" [halfHeight]="halfHeight">
  <div card-header>
    <h1>{{'lang.dashboard.broadcastingQuota' | translate}}</h1>
    <small>{{ 'lang.globals.betweenCountDays' | translate: {count: timespan ? timespan?.days : ' - '} }}</small>
  </div>
  <div card-header-more>
    <div class="font-weight-normal text-end" style="font-size: 12px" #chartLegend></div>
  </div>
  <sb-chart #chart chartType="lineChart" card-body [chartData]="airTimeData"></sb-chart>
</sb-card>
<div *ngIf="integratedChart">
  <sb-chart #integratedChart chartType="lineChart" card-body [chartData]="airTimeData"></sb-chart>
</div>
